import {importDynamicModulesList} from "@nextories/vue-core-components/src/utils/helpers/format";

const bookingSteps = import.meta.glob('./booking/steps/*.vue', { eager: true });
const smallCards = import.meta.glob('./home/smallCards/*.vue', { eager: true });

export default importDynamicModulesList([bookingSteps, smallCards]);
